import { styleMap } from "lit-html/directives/style-map.js";
const overlayStyle = ({ dsf_overlay }) => styleMap({
  zIndex: "var(--dsf-z-index-modal)",
  background: dsf_overlay ? "rgba(var(--dsf-color-neutral-700), 0.85)" : ""
});
export {
  overlayStyle
};
